import { useTraduction } from "../../Contexte/TraductionContext"

function TravaillerEnsemble() {

    const { contentAccueil } = useTraduction()
    
    return <>

    <section id="Travaille" className="container mt-124">
        <h3>{contentAccueil.GrosTitreTravail}</h3>
        <div className="container-argus mt-64">
            <div className="container-argu">
                <span className="red-circle"><p>1</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg1.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg1.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>2</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg2.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg2.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>3</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg3.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg3.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>4</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg4.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg4.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>5</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg5.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg5.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>6</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg6.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg6.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>7</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg7.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg7.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>8</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg8.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg8.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>9</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg9.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg9.Description}</p>
            </div>

            <div className="container-argu">
                <span className="red-circle"><p>10</p></span>
                <p className="Argument mt-16">{contentAccueil.TravailArg10.Titre}</p>
                <p className="Argumentation">{contentAccueil.TravailArg10.Description}</p>
            </div>
        </div>

    </section>
    
    </>
}

export default TravaillerEnsemble